import { Hash as SdkNodeHash } from "@aws-sdk/hash-node";
// TODO: remove the following when SdkNodeHash has implemented Checksum interface in aws-sdk-js-v3
var NodeHash = /** @class */ (function () {
    function NodeHash(algorithmIdentifier, secret) {
        this.secret = secret;
        this.nodeHash = new SdkNodeHash("sha256", secret);
    }
    NodeHash.prototype.digest = function () {
        return this.nodeHash.digest();
    };
    NodeHash.prototype.reset = function () {
        this.nodeHash = new SdkNodeHash("sha256", this.secret);
    };
    NodeHash.prototype.update = function (chunk) {
        this.nodeHash.update(chunk);
    };
    return NodeHash;
}());
export { NodeHash };
//# sourceMappingURL=node_hash.js.map